import { connect } from "react-redux";
import {
  LicensePlateLookup as Component,
  LicensePlateLookupProps,
} from "./LicensePlateLookup.component";
import {
  changeLookupTypeMethod,
  resetSearchResults,
  searchByLicensePlate,
  setLicensePlate,
  resetVinSearchResult
} from "../../action/licensePlateVinLookup-action";
import { RootState } from "../../reducers";
import { getVinSearchResults } from "../../selector";

const mapStateToProps = (state: RootState) => {
  return {
    vinSearchResult: getVinSearchResults(state),
  };
};

export const LicensePlateLookup = connect(mapStateToProps, {
  changeLookupTypeMethod,
  setLicensePlate,
  searchByLicensePlate,
  resetSearchResults,
  // Future state method to differentiate between memberlookup and addVehicle flows
  // setRoute:
  resetVinSearchResult
} as Pick<LicensePlateLookupProps, "changeLookupTypeMethod" | "setLicensePlate" | "searchByLicensePlate" 
| "resetSearchResults" | "resetVinSearchResult">)(
  Component
);
